import { LitElement, html } from "lit-element"
import { classMap } from "lit-html/directives/class-map"
import commonStyle from "../common.css"
import style from "./badge.css"

export default class extends LitElement {
	static get properties () {
		return {
			displayValue: { type: String }
		}
	}

	constructor () {
		super()
		this.displayValue = ""
	}

	render () {
		return html`
			<span class = "badge-wrapper">
				<slot></slot>
			<div class = ${this.badgeClass}>	${this.displayValue}</div>
			</span>
				<style>
					${commonStyle}
					${style}
				</style>
		`
	}

	get badgeClass () {
		let hide = false
		if (this.displayValue === "0" || !this.displayValue) {
			hide = true
		}
		return classMap({
			badge: true,
			"is-hide": hide
		})
	}
}
